import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import SelectAutoInput from "../../inputs/SelectAutoInput";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

const RffSelectAutocompleteField = ({
  name,
  label,
  options,
  required = false,
  suppressGrid,
  size,
  alphabetize = false,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  const sortedOptions = useMemo(() => {
    if (!alphabetize || !options) return options;

    return [...options].sort((a, b) => {
      // Handle different option formats
      const labelA =
        typeof a === "string" ? a : a?.label || a?.name || String(a);
      const labelB =
        typeof b === "string" ? b : b?.label || b?.name || String(b);

      return labelA.localeCompare(labelB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, [options, alphabetize]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <SelectAutoInput
            label={label}
            value={input?.value}
            onChange={(v) => {
              input.onChange(v);
            }}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            options={sortedOptions}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffSelectAutocompleteField;
